import styled from 'styled-components';
import { ASSETS } from '../../../../assets';

export const Icon = styled(ASSETS.APP_LOADER)`
    width: 128px;
    height: 128px;
`;
